export const SIGNUP_CODE_SESSION_KEY = "pending_signup_code";

const SIGNUP_HASH = "#signup";

export const getSignupLinkData = () => {
  const url = new URL(window.location.href);
  const code = url.searchParams.get("code")?.trim() || "";
  const shouldForceSignup =
    code.length > 0 && url.hash.toLowerCase() === SIGNUP_HASH;

  return {
    code,
    shouldForceSignup,
  };
};

export const storePendingSignupCode = (code: string) => {
  if (!code) return;
  sessionStorage.setItem(SIGNUP_CODE_SESSION_KEY, code);
};

export const getPendingSignupCode = () => {
  return sessionStorage.getItem(SIGNUP_CODE_SESSION_KEY) || "";
};

export const clearPendingSignupCode = () => {
  sessionStorage.removeItem(SIGNUP_CODE_SESSION_KEY);
};

export const clearSignupParamsFromUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete("code");
  if (url.hash.toLowerCase() === SIGNUP_HASH) {
    url.hash = "";
  }
  window.history.replaceState({}, "", url.toString());
};
